import { colors } from '../../ui';
import { Legend } from '../../screens/optician/testScreenKit';

// Visual Field live counts (Figma session/12 left): Seen, Not seen, Not seen once, To be displayed,
// Blindspot (+ Out of Bounds when any). Colours match VisualFieldMatrixVF2's dots.
export const VF2_DOT_COLORS = {
  seen: '#6DC89D',
  notSeen: '#8B1A1A',
  missedOnce: '#F0B729',
  toBeDisplayed: '#8A9393',
  blindspot: '#000000',
  outOfBounds: colors.error[200],
};

const PatientResponseSidebarVF2 = ({ testProgressData }) => {
  const outOfBoundsDots = testProgressData.outOfBoundariesDots?.length || 0;
  const calculateDotsForDisplay = () => {
    const { testEnded, dotsForDisplay } = testProgressData;
    if (testEnded) {
      return 0;
    } else {
      return dotsForDisplay?.length || 0;
    }
  };
  const shown = testProgressData?.totalBlindSpotsShown;

  return (
    <Legend
      data-testid='vf-legend'
      items={[
        { color: VF2_DOT_COLORS.seen, label: `Seen (${testProgressData?.seenDots?.length || 0})` },
        { color: VF2_DOT_COLORS.notSeen, label: `Not seen (${testProgressData?.notSeenDots?.length || 0})` },
        { color: VF2_DOT_COLORS.missedOnce, label: `Not seen once (${testProgressData?.missedOnceDots?.length || 0})` },
        { color: VF2_DOT_COLORS.toBeDisplayed, label: `To be displayed (${calculateDotsForDisplay() || 0})` },
        { color: VF2_DOT_COLORS.blindspot, label: `Blindspot (shown ${shown ?? 0} time${shown === 1 ? '' : 's'})` },
        ...(outOfBoundsDots ? [{ color: VF2_DOT_COLORS.outOfBounds, label: `Out of Bounds (${outOfBoundsDots})` }] : []),
      ]}
    />
  );
};

export default PatientResponseSidebarVF2;
